import { useCallback } from "react";
import { useSearchParams } from "react-router";

/**
 * 주소의 검색 조건을 고친다. 지금 주소에서 읽어 고친다: useSearchParams의 이전 값으로 고치면
 * 막 바뀐 주소(할일 상세 닫기 등)가 아직 화면에 반영되기 전이라 되살아날 수 있다.
 */
export function useUpdateParams() {
  const [, setParams] = useSearchParams();
  return useCallback(
    (fn: (p: URLSearchParams) => void) => {
      const p = new URLSearchParams(window.location.search);
      fn(p);
      setParams(p);
    },
    [setParams],
  );
}
